const globals = {
  '*': { boxSizing: 'border-box' },
  'body, html': {
    width: '100%',
    minHeight: '100%',
    fontFamily: '$base',
    margin: 0,
    cursor: 'default',
  },
  html: {
    backgroundColor: '$black',
    scrollBehavior: 'initial'
  },
}

export default globals
